var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            design: "v3",
            "class-name": "bulk-note-modal",
            "show-footer": false,
            "show-title": false,
          },
          on: { cancel: _vm.onCancel },
        },
        [
          _c("div", { staticClass: "bulk-note-modal-content" }, [
            _c("div", { staticClass: "modal-section" }, [
              _c("div", { staticClass: "note-editor-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("edit_note"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("auto.noteContent")))]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "editor-container" },
                  [
                    _c("a-textarea", {
                      staticClass: "note-textarea",
                      attrs: {
                        rows: 8,
                        placeholder: _vm.$t("auto.writeNoteContentHere"),
                        maxLength: 500,
                      },
                      model: {
                        value: _vm.description,
                        callback: function ($$v) {
                          _vm.description = $$v
                        },
                        expression: "description",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "editor-footer" }, [
                      _c("div", { staticClass: "help-text" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("info_outline"),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("auto.sameNoteWillBeAddedToAllContacts")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "char-counter",
                          class: {
                            warning: _vm.description.length > 450,
                            danger: _vm.description.length >= 490,
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.$t("auto.noteCharCounter", {
                                  current: _vm.description.length,
                                  max: 500,
                                })
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "visibility-wrapper" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("visibility"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("auto.noteVisibility")))]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "visibility-options" }, [
                  _c(
                    "div",
                    {
                      staticClass: "visibility-card",
                      class: { selected: !_vm.isPrivate },
                      on: {
                        click: function ($event) {
                          _vm.isPrivate = false
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-icon public-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("public"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.$t("auto.publicNote"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-description" }, [
                          _vm._v(_vm._s(_vm.$t("auto.allTeamMembersCanSee"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selection-indicator" }, [
                        !_vm.isPrivate
                          ? _c("i", { staticClass: "material-icons" }, [
                              _vm._v("check_circle"),
                            ])
                          : _c("i", { staticClass: "material-icons" }, [
                              _vm._v("radio_button_unchecked"),
                            ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "visibility-card",
                      class: { selected: _vm.isPrivate },
                      on: {
                        click: function ($event) {
                          _vm.isPrivate = true
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "card-icon private-icon" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("lock"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "card-title" }, [
                          _vm._v(_vm._s(_vm.$t("auto.privateNote"))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-description" }, [
                          _vm._v(_vm._s(_vm.$t("auto.onlyYouCanSee"))),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "selection-indicator" }, [
                        _vm.isPrivate
                          ? _c("i", { staticClass: "material-icons" }, [
                              _vm._v("check_circle"),
                            ])
                          : _c("i", { staticClass: "material-icons" }, [
                              _vm._v("radio_button_unchecked"),
                            ]),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("SupsisButton", { on: { click: _vm.onCancel } }, [
                  _vm._v(_vm._s(_vm.$t("auto.cancel"))),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  { attrs: { primary: "" }, on: { click: _vm.onConfirm } },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("add_comment"),
                    ]),
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("auto.addNote")) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }